/**
 * Props definitions for LoadingOverlay component.
 */
interface LoadingOverlayProps {
    isActive: boolean,
    loadingText: string,
}

/**
 * Loading overlay indicator component.
 * @param props 
 * @returns 
 */
export const LoadingOverlay: React.FC<LoadingOverlayProps> = (props) => {
    
    return (
        <div className={`overlay ${!props.isActive ? 'hidden' : ''}`}>
            <div className="overlay-inner">
                <div className="overlay-content">
                    <span className="spinner"></span>
                    <p>{props.loadingText}</p>
                </div>
            </div>
        </div>
    )
}
